import React from 'react';
import {
  Form, Row, Col, Select, Button, message, Icon, Radio, Switch, Checkbox
} from 'antd';
import moment from "moment";
import MiCompAPI from "../../../util/api";
const { Option } = Select;
class FD extends React.Component {
  handleSubmit = (e) => {
    
    e.preventDefault();
    this.state.showfields===true?
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.form.resetFields();
        this.props.submitHandler({ ...values, client_id: this.props.client_id },"old");
      }
    }):
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.form.resetFields();
        this.props.submitHandler({ ...values, client_id: 0 },"new");
      }
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      tier_id: 0,
      istier_idSel: false,
      from_profile_id: 0,
      isfrom_profile_idSel: false,
      plan: [],
      from_profile: [],
      to_profile: [],
      showfields: false,
      users: [],
      assignTo: []
    }
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.GetPlanByClient_id();
  }
  GetPlanByClient_id = () => {
    this.api.invoke(
      "GetPlanByClient_id/" + this.props.client_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              plan: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  GetToProfileByTierId = (tier_id, from_profile_id) => {
    this.api.invoke(
      "GetToProfileByTierId/" + tier_id + "/" + from_profile_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              to_profile: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
    this.api.invoke(
      "getAllContactsofLoggedinUser/",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              users: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  GetFromProfileByTierId = (tier_id) => {
    this.api.invoke(
      "GetFromProfileByTierId/" + tier_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              from_profile: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  GetAllClient_Tier_ProfileByTierId = (tier_id) => {
    this.api.invoke(
      "GetAllClient_Tier_ProfileByTierId/" + tier_id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              from_profile: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }

  change = (e) => {
    const { setFieldsValue } = this.props.form;
    setFieldsValue({
      from_profile_id: "Please Select",
      to_profile_id: "Please Select"
    })
    this.setState({ tier_id: e });
    setTimeout(() => {
      this.GetFromProfileByTierId(e);
    }, 3);
  }
  change1 = (e) => {
    const { setFieldsValue } = this.props.form;
    setFieldsValue({
      from_profile_id: "Please Select",
      to_profile_id: "Please Select"
    })
    this.setState({ tier_id: e });
    setTimeout(() => {
      this.GetAllClient_Tier_ProfileByTierId(e);
    }, 3);
  }
  changeFrom = (e) => {    
    const { setFieldsValue } = this.props.form;
    setFieldsValue({
      to_profile_id: "Please Select"
    })
    this.setState({ from_profile_id: e });
    setTimeout(() => {
      this.GetToProfileByTierId(this.state.tier_id, e);
    }, 3);
  }
  profileAssign = (e) => {    
    this.setState({
      assignTo: e,
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div>

        <Row span={24} >
          <Switch defaultChecked style={{ marginLeft: '15px' }}
            onChange={() => this.setState({ showfields: !this.state.showfields })}
          />
          {this.state.showfields ? <span style={{ fontWeight: 'bold', marginLeft: '6px', fontSize: '18px' }}>Old Profile</span> :
            <span style={{ fontWeight: 'bold', marginLeft: '6px', fontSize: '18px' }}>New Profile</span>}
        </Row>

        <Row span={24} >
          <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark style={{ marginTop: '15px' }}>
            <Row span={24} >
              {this.state.showfields ?
                <>
                  <Col md={12} sm={24}>
                    <Form.Item>
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">Plan</legend>
                        {getFieldDecorator('tier_id', {
                          rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Plan. </span> }],
                        })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                          onChange={this.change.bind(this)}
                          optionFilterProp="children"
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Please Select Plan * ">
                          {this.state.plan.map(tag => <Option value={tag.tier_id} key={tag.tier_id}>{tag.plan_Name} ({moment(tag.start_date).format("MM/DD/YYYY")}-{tag.end_date != null ? moment(tag.end_date).format("MM/DD/YYYY") : "none"})</Option>)}
                        </Select>)}
                      </fieldset>
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={24}>
                    <Form.Item>
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">From Profile</legend>
                        {getFieldDecorator('from_profile_id', {
                          rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select From Profile. </span> }
                          ],
                        })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                          optionFilterProp="children"
                          onMouseEnter={() => this.setState({ istier_idSel: this.state.tier_id === 0 ? true : false })}
                          onChange={this.changeFrom.bind(this)}
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Please Select From Profile *">
                          {this.state.from_profile.map(tag => <Option value={tag.id} key={tag.id}>{tag.name} ({moment(tag.startDate).format("MM/DD/YYYY")}-{tag.endDate != null ? moment(tag.endDate).format("MM/DD/YYYY") : "none"})</Option>)}
                        </Select>)}
                      </fieldset>
                      {this.state.istier_idSel ? <p style={{ color: 'red', marginLeft: '8px' }}>Please select Plan First</p> : ""}              </Form.Item>
                  </Col></>
                :
                <>
                  <Col md={12} sm={24}>
                    <Form.Item>
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">Plan</legend>
                        {getFieldDecorator('tier_id', {
                          rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Plan. </span> }],
                        })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                          onChange={this.change1.bind(this)}
                          optionFilterProp="children"
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Please Select Plan * ">
                          {this.state.plan.map(tag => <Option value={tag.tier_id} key={tag.tier_id}>{tag.plan_Name} ({moment(tag.start_date).format("MM/DD/YYYY")}-{tag.end_date != null ? moment(tag.end_date).format("MM/DD/YYYY") : "none"})</Option>)}
                        </Select>)}
                      </fieldset>
                    </Form.Item>
                  </Col>
                  <Col md={12} sm={24}>
                    <Form.Item>
                      <fieldset className="mi_input_pop">
                        <legend className="legend-font">From Profile</legend>
                        {getFieldDecorator('from_profile_id', {
                          rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select From Profile. </span> }
                          ],
                        })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                          optionFilterProp="children"
                          onMouseEnter={() => this.setState({ istier_idSel: this.state.tier_id === 0 ? true : false })}
                          onChange={this.changeFrom.bind(this)}
                          showSearch={true}
                          filterOption={(input, option) =>
                            option.props.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder="Please Select From Profile *">
                          {this.state.from_profile.map(tag => <Option value={tag.tier_profile_id} key={tag.id}>{tag.tier_profile_name} ({moment(tag.startDate).format("MM/DD/YYYY")}-{tag.endDate != null ? moment(tag.endDate).format("MM/DD/YYYY") : "none"})</Option>)}
                        </Select>)}
                      </fieldset>
                      {this.state.istier_idSel ? <p style={{ color: 'red', marginLeft: '8px' }}>Please select Plan First</p> : ""}              </Form.Item>
                  </Col>
                </>
              }


            </Row>
            <Row span={24}>
              {this.state.showfields &&
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">To Profile</legend>
                      {getFieldDecorator('to_profile_id', {
                        rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select To Profile. </span> }
                        ],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        onMouseEnter={() => this.setState({ istier_idSel: this.state.tier_id === 0 ? true : false, isfrom_profile_idSel: this.state.from_profile_id ? true : false })}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select To Profile * ">
                        {this.state.to_profile.map(tag => <Option value={tag.id} key={tag.id}>{tag.name} ({moment(tag.startDate).format("MM/DD/YYYY")}-{tag.endDate != null ? moment(tag.endDate).format("MM/DD/YYYY") : "none"})</Option>)}
                      </Select>)}
                    </fieldset>
                    {this.state.istier_idSel ? <p style={{ color: 'red', marginLeft: '8px' }}>Please select Plan First</p> : ""}
                    {/* {this.state.isfrom_profile_idSel ? <p style={{ color: 'red', marginLeft: '8px' }}>Please select From Profile First</p> : ""} */}
                  </Form.Item>
                </Col>}
              {this.state.showfields && this.state.showfields === true ?
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Assign To</legend>
                      {getFieldDecorator('assign_to', {
                        rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Assign To. </span> }],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        placeholder="Please Select Assign To ">
                        <Option value="all" key="all">All</Option>
                        <Option value="broker" key="broker">All Brokers</Option>
                        <Option value="agency" key="agency"> All Agencies</Option>
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col> :
                <Col md={12} sm={24}>
                  <Form.Item>
                    <fieldset className="mi_input_pop">
                      <legend className="legend-font">Assign To</legend>
                      {getFieldDecorator('assign_to', {
                        rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Assign To. </span> }],
                      })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                        optionFilterProp="children"
                        showSearch={true}
                        mode="multiple"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={this.profileAssign.bind(this)}
                        placeholder="Please Select Assign To ">
                        {this.state.users.map(tag => <Option value={tag.userId} key={tag.userId}>{tag.name}({tag.role}) </Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item>
                </Col>}

            </Row>
            <Row span={24} style={{ marginTop: '20px' }}>
              <Col span={24} >
                <Button className='submit-button' htmlType="submit" type="primary" style={{ float: "right" }}>
                  Submit
                </Button>            </Col>
            </Row>
          </Form>
        </Row>
      </div>

    );
  }
}
const MassProfileAssgin = Form.create()(FD);
export default MassProfileAssgin;